import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, forkJoin, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { Organization } from './organization.model';
import Env from '@ridango/core/env';

@Injectable()
export class OrganizationsService {
    constructor(
        @Inject('ENV') private env: Env,
        private http: HttpClient
    ) {}

    fetchOrganizations(): Observable<Organization[]> {
        const url = `${this.env.WMB.WMB_PUBLIC_API}/v1/organization`;
        return this.http.get<Organization[]>(url);
    }

    fetchOrganizationById(organizationId: number): Observable<Organization> {
        const url = `${this.env.WMB.WMB_PUBLIC_API}/v1/organization/${organizationId}`;
        return this.http.get<Organization>(url);
    }

    fetchOrganizationsByIds(organizationIds: number[]): Observable<Organization[]> {
        if (!organizationIds || organizationIds.length === 0) {
            return of([]);
        }
        const uniqueIds = [...new Set(organizationIds)];
        const requests = uniqueIds.map((id) => this.fetchOrganizationById(id));
        return forkJoin(requests).pipe(map((organizations) => organizations.filter((org) => org !== null)));
    }
}
